import { render, staticRenderFns } from "./ChoosePrivilegeModal.vue?vue&type=template&id=7fd480be&scoped=true&"
import script from "./ChoosePrivilegeModal.vue?vue&type=script&lang=js&"
export * from "./ChoosePrivilegeModal.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePrivilegeModal.vue?vue&type=style&index=0&id=7fd480be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd480be",
  null
  
)

export default component.exports